import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaArrowRight, FaFolder, FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "./Documents.module.css";
import { testUrl } from "../BaseData";
import documeticon from "./document.jpeg";
import { CopyAll } from "@mui/icons-material";

const Documents = () => {
    const { t, i18n } = useTranslation();
    const [documents, setDocuments] = useState([]);
    const { short_name } = useParams();
    const [documenttype, setDocumenttype] = useState(null);
    const navigate = useNavigate();

    let fetchShortName = short_name;
    let isCategoryView = false;
    let categoryToFilter = null;

    if (short_name === 'normativ' || short_name === 'ichki') {
        fetchShortName = 'normativ-huquqiy-hujjatlar';
        isCategoryView = true;
        categoryToFilter = short_name;
    }

    useEffect(() => {
        axios
            .get(
                testUrl + "/api/documents/" + fetchShortName
            )
            .then((response) => {
                setDocuments(response?.data);
            })
            .catch((error) =>
                console.error("Error fetching documents data: ", error)
            );
        axios
            .get(
                testUrl + "/api/documentstype/" + fetchShortName
            )
            .then((response) => {
                setDocumenttype(response?.data || null);
            })
            .catch((error) =>
                console.error("Error fetching documents data: ", error)
            );
    }, [fetchShortName, i18n.language]);


    const getDocumentsName = (document) => {
        if (!document) return t("no_name_available");
        const title = document[`name_${i18n.language}`];
        return title || document.name_uz || t("no_name_available");
    };

    const normativDocs = documents.filter(doc => doc.document_category === 'normativ' || !doc.document_category);
    const ichkiDocs = documents.filter(doc => doc.document_category === 'ichki');

    const docsToRender = isCategoryView
        ? (categoryToFilter === 'normativ' ? normativDocs : ichkiDocs)
        : documents;

    const renderDocuments = (docs, startIndex = 0) => (
        <div className={styles.facultyList}>
            {docs.length > 0 ? (
                docs.map((document, index) => (
                    <a key={document.id}
                        href={document.document}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.documentCard}>
                        <div className={styles.iconWrapper}>
                            <img src={documeticon} alt="doc icon" className={styles.documentIcon} />
                        </div>
                        <div className={styles.documentInfo}>
                            <span className={styles.documentTitle}>{startIndex + index + 1}. {getDocumentsName(document)}</span>
                        </div>
                        <div className={styles.arrowWrapper}>
                            <FaArrowRight className={styles.arrowIcon} />
                        </div>
                    </a>
                ))
            ) : (
                <div style={{ padding: "20px" }}>
                    {t("no_document_found")}
                </div>
            )}
        </div>
    );


    return (
        <div className={styles.mainContainer}>
            <div className={styles.container}>

                {/* Departments Section */}
                <div className={styles.section}>

                    {!isCategoryView && (
                        <h3 className={styles.title}>
                            {documenttype ? documenttype[`name_${i18n.language}`] : t("loading")}
                        </h3>
                    )}

                    {isCategoryView && (
                        <h3 className={styles.title} style={{ marginBottom: '30px' }}>
                            {categoryToFilter === 'normativ' ? 'Normativ-huquqiy hujjatlar' : 'Ichki hujjatlar'}
                        </h3>
                    )}

                    {short_name === 'normativ-huquqiy-hujjatlar' ? (
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'stretch' }}>
                            <div className={styles.documentCard} style={{ cursor: 'pointer', padding: '12px 24px', minHeight: '80px', width: '100%', boxSizing: 'border-box' }} onClick={() => navigate('/documents/normativ')}>
                                <div className={styles.iconWrapper}>
                                    <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#f2f6fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <FaFolder size={24} color="#133654" />
                                    </div>
                                </div>
                                <div className={styles.documentInfo}>
                                    <span className={styles.documentTitle} style={{ fontSize: '16px' }}>Normativ-huquqiy hujjatlar</span>
                                </div>
                                <div className={styles.arrowWrapper}>
                                    <FaArrowRight className={styles.arrowIcon} style={{ fontSize: '20px' }} />
                                </div>
                            </div>

                            <div className={styles.documentCard} style={{ cursor: 'pointer', padding: '12px 24px', minHeight: '80px', width: '100%', boxSizing: 'border-box' }} onClick={() => navigate('/documents/ichki')}>
                                <div className={styles.iconWrapper}>
                                    <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#f2f6fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <FaFolder size={24} color="#133654" />
                                    </div>
                                </div>
                                <div className={styles.documentInfo}>
                                    <span className={styles.documentTitle} style={{ fontSize: '16px' }}>Ichki hujjatlar</span>
                                </div>
                                <div className={styles.arrowWrapper}>
                                    <FaArrowRight className={styles.arrowIcon} style={{ fontSize: '20px' }} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        renderDocuments(docsToRender)
                    )}
                </div>
            </div>
        </div>
    );
};

export default Documents;
